export enum EpsgCode {
  Wgs84 = "EPSG:4326",
}
